export var ACTION;
(function (ACTION) {
    ACTION["TEST_ACTION"] = "TEST_ACTION";
    ACTION["VERIFY_KYC_SUMMARY"] = "VERIFY_KYC_SUMMARY";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["TOGGLE_CTA"] = "TOGGLE_CTA";
    ACTION["NAVIGATION_NEXT"] = "NAVIGATION_NEXT";
    ACTION["NAVIGATION_CO_BORROWER_PAN"] = "NAVIGATION_CO_BORROWER_PAN";
    ACTION["NAVIGATE_TO_KYC"] = "NAVIGATE_TO_KYC";
})(ACTION || (ACTION = {}));
